<template>
  <div>
    <router-view/>
  </div>
</template>


<!--<link-->
<!--    rel="stylesheet"-->
<!--    href="https://cdn.jsdelivr.net/npm/vant@2.12/lib/index.css"-->
<!--/>-->

<!--&lt;!&ndash; 引入 Vue 和 Vant 的 JS 文件 &ndash;&gt;-->

<!--&lt;!&ndash;<script src="https://cdn.jsdelivr.net/npm/vue@2.6/dist/vue.min.js"></script>&ndash;&gt;-->
<!--<script src="https://cdn.jsdelivr.net/npm/vant@2.12/lib/vant.min.js"></script>-->




<script>



export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;

}
</style>
